/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetStripeOneTimeProductsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetStripeOneTimeProductsQuery = { __typename?: 'Query', stripeOneTimeProducts?: Array<{ __typename?: 'StripeProduct', id: string, name?: string | null, description?: string | null, images?: Array<string> | null, default_price?: { __typename?: 'StripePrice', id: string, unit_amount: number } | null, metadata?: { __typename?: 'Metadata', order_number?: string | null, free_tag_limit?: string | null } | null } | null> | null };


export const GetStripeOneTimeProductsDocument = gql`
    query getStripeOneTimeProducts {
  stripeOneTimeProducts {
    id
    name
    description
    images
    default_price {
      id
      unit_amount
    }
    metadata {
      order_number
      free_tag_limit
    }
  }
}
    `;

/**
 * __useGetStripeOneTimeProductsQuery__
 *
 * To run a query within a React component, call `useGetStripeOneTimeProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStripeOneTimeProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStripeOneTimeProductsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetStripeOneTimeProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>(GetStripeOneTimeProductsDocument, options);
      }
export function useGetStripeOneTimeProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>(GetStripeOneTimeProductsDocument, options);
        }
export function useGetStripeOneTimeProductsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>(GetStripeOneTimeProductsDocument, options);
        }
export type GetStripeOneTimeProductsQueryHookResult = ReturnType<typeof useGetStripeOneTimeProductsQuery>;
export type GetStripeOneTimeProductsLazyQueryHookResult = ReturnType<typeof useGetStripeOneTimeProductsLazyQuery>;
export type GetStripeOneTimeProductsSuspenseQueryHookResult = ReturnType<typeof useGetStripeOneTimeProductsSuspenseQuery>;
export type GetStripeOneTimeProductsQueryResult = Apollo.QueryResult<GetStripeOneTimeProductsQuery, GetStripeOneTimeProductsQueryVariables>;